<template>
    <div class="mt-4">
        <div v-show="!clientDetail">
            <div class="table-full-width table-responsive">
                <table v-if="disciplines" class=" table-rating">
                    <thead>
                        <tr>
                            <th class="col-full"></th>
                            <th valign="center" v-for="(discipline,key) in disciplines" :key="discipline.id">
                                {{discipline.title}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(client, key) in clients" :key="client.id">
                            <td class="col-full"> <span @click="getClientDetail(client)" class="client-detail">
                                    {{client.id}} /
                                    {{client.full_name  | maxChar(30) }} <span class="icon ti-info"></span></span></td>
                            <td align="center" :title="client.full_name" v-for="(discipline,key) in disciplines"
                                :key="discipline.id">
                                {{getStat(client, discipline)}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h5 v-else>Нет записей</h5>
            </div>
        </div>
        <div v-show="clientDetail">
            <button @click="clientDetail = null" class="btn btn-sm">Назад</button>
            <client-card :client="clientDetail" :disciplines="disciplines" />
        </div>
    </div>
</template>

<script>
import ClientCard from "./ClientCard.vue";

export default {

    components: {
        ClientCard
    },
    created() {

    },
    data() {
        return {
            clientDetail: null
        };
    },
    props: ["clients", "disciplines", "group", "part"],
    methods: {
        //установка планового урока
        getStat(client, discipline) {
            for (let i = 0; i < client.process_results.length; i++) {
                if (client.process_results[i].discipline_id == discipline.id) {
                    return client.process_results[i].value;
                }
            }
            return '-';
        },
        getClientDetail(client) {
            this.clientDetail = client;
        }
    }
};
</script>

<style lang="scss">
.client-detail {
    cursor: pointer;

    &>span {
        background: #fafafa;
        border-radius: 5px;
        border: 1px solid #888;
        padding: 2px;
        margin-left: 5px;
    }
}
</style>

